import { render, staticRenderFns } from "./PcStatusChip.vue?vue&type=template&id=b5871664"
import script from "./PcStatusChip.vue?vue&type=script&lang=js"
export * from "./PcStatusChip.vue?vue&type=script&lang=js"
import style0 from "./PcStatusChip.vue?vue&type=style&index=0&id=b5871664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
